import { render, staticRenderFns } from "./AmenityItem.vue?vue&type=template&id=78f5f052&scoped=true&"
import script from "./AmenityItem.vue?vue&type=script&lang=js&"
export * from "./AmenityItem.vue?vue&type=script&lang=js&"
import style0 from "./AmenityItem.vue?vue&type=style&index=0&id=78f5f052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5f052",
  null
  
)

export default component.exports